import { ElementType, useElementIndex } from '../../contexts/elementIndex';

export const useCurrentCriteriaIndex = () => useElementIndex(ElementType.Criteria);
